(() => {
  const DISCOUNT_CODE = 'BMP90';
  const APPLIED_STORAGE_KEY = 'lp04DailyEssentialsDiscountApplied';
  const LOG = '[HOWL]';

  const storeRoot = () => window.Shopify?.routes?.root || '/';

  const applyDiscountCode = async (code) => {
    const storedCode = sessionStorage.getItem(APPLIED_STORAGE_KEY);

    console.log(LOG, 'start', {
      href: window.location.href,
      code,
      storedCode,
      storeRoot: storeRoot(),
    });

    if (storedCode === code) {
      console.log(LOG, 'skipped: sessionStorage already has this code');
      return;
    }

    const root = storeRoot();
    const updateUrl = `${root}cart/update.js`;

    try {
      console.log(LOG, 'POST', updateUrl, { discount: code });

      const response = await fetch(updateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ discount: code }),
      });

      const responseText = await response.text();

      console.log(LOG, 'cart/update.js response', {
        ok: response.ok,
        status: response.status,
        body: responseText,
      });

      if (response.ok) {
        sessionStorage.setItem(APPLIED_STORAGE_KEY, code);
        console.log(LOG, 'applied via cart/update.js');
        return;
      }

      console.log(LOG, 'cart/update.js was not ok, trying discount URL');
    } catch (error) {
      console.log(LOG, 'cart/update.js threw, trying discount URL', error);
    }

    const discountUrl = `${root}discount/${encodeURIComponent(code)}`;

    try {
      console.log(LOG, 'GET', discountUrl);

      const discountResponse = await fetch(discountUrl, {
        credentials: 'same-origin',
        redirect: 'manual',
      });

      console.log(LOG, 'discount URL response', {
        ok: discountResponse.ok,
        status: discountResponse.status,
        type: discountResponse.type,
        redirected: discountResponse.redirected,
        url: discountResponse.url,
      });
    } catch (error) {
      document.cookie = `discount_code=${encodeURIComponent(code)}; path=/`;
      console.log(LOG, 'discount URL threw, set discount_code cookie', error);
    }

    sessionStorage.setItem(APPLIED_STORAGE_KEY, code);
    console.log(LOG, 'finished fallback and stored code in sessionStorage', {
      cookie: document.cookie,
    });
  };

  applyDiscountCode(DISCOUNT_CODE);
})();
